module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAS1BMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzMpLzN6gIRVrO7h6O2Rl5zW3OE8ZoU6XnlQnNfK0dZSpOI1Oz8sNz9udHmco6cK+TT/AAAACnRSTlMA358QUGDvQL+AzL8+UAAAAMFJREFUeF7t2MkKwzAMRVHJdqaXufP/f2mzqXEghigRtFDdnTYHtBKIlnzDOBYXlBRKHM/56FQ4lYsQQ0cqNoCh39VrJdUbUL+zeypBACG2np0WBKcFwWlBCFoQa0EwyKA0gwzaUR6Sn6MhA8n7Q2i6dYJuUw6aO2FzBrpIoUsG6sQ9fg7KrNaL+wJkkEEGGWSQQQZdpc51BXEcWin0TJyaGsTaUcKMLZIK8iUUYiIKUKiipYpxsjJ83mM1TsSNJ6I3wvHkRvtkchAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4be.png
// module id = 1013
// module chunks = 0